import { useEffect, useRef } from 'react';

import { Portal } from 'components/organisms/SalaryOptions/common/Portal';
import { ReactComponent as CloseIcon } from 'utils/assets/images/closeIconModal.svg';

import { CropImageSection } from './CropImageSection/CropImageSection.component';
import { CropStateMessage } from './CropStateMessage/CropStateMessage.component';
import { ModalEditButtons } from './ModalEditButtons/ModalEditButtons.component';
import { useCropImageContext } from './useCropImageContext/useCropImageContext';
import { MODAL_TITLE } from './utils/constants';

import styles from './ModalCropImage.module.scss';

export const ModalCropImage = () => {
  const { setSuccessfulUpload, openModal, isErrorSaving, isWarningExit, secureExitModal } =
    useCropImageContext();

  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSuccessfulUpload(null);
  }, [setSuccessfulUpload]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        secureExitModal();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [secureExitModal]);

  if (!openModal) return <></>;

  return (
    <Portal>
      <div className={styles.modal} data-testid='container'>
        <aside className={styles.modal__container} ref={modalRef}>
          <div className={styles.modal__header}>
            {!isWarningExit && !isErrorSaving && (
              <h3 className={styles.modal__header__title}>{MODAL_TITLE}</h3>
            )}
            <button className={styles.modal__header__close} onClick={secureExitModal}>
              <CloseIcon />
            </button>
          </div>
          {(isWarningExit || isErrorSaving) && <CropStateMessage />}
          {!isWarningExit && !isErrorSaving && <CropImageSection />}
          <ModalEditButtons />
        </aside>
      </div>
    </Portal>
  );
};
